var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49935 4.16665L8.97612 9.20413C9.57797 9.67224 10.4207 9.67224 11.0226 9.20413L17.4993 4.16665M4.33268 16.6666H15.666C16.5994 16.6666 17.0661 16.6666 17.4227 16.485C17.7363 16.3252 17.9912 16.0702 18.151 15.7566C18.3327 15.4001 18.3327 14.9334 18.3327 14V5.99998C18.3327 5.06656 18.3327 4.59985 18.151 4.24333C17.9912 3.92973 17.7363 3.67476 17.4227 3.51497C17.0661 3.33331 16.5994 3.33331 15.666 3.33331H4.33268C3.39926 3.33331 2.93255 3.33331 2.57603 3.51497C2.26243 3.67476 2.00746 3.92973 1.84767 4.24333C1.66602 4.59985 1.66602 5.06656 1.66602 5.99998V14C1.66602 14.9334 1.66602 15.4001 1.84767 15.7566C2.00746 16.0702 2.26243 16.3252 2.57603 16.485C2.93255 16.6666 3.39926 16.6666 4.33268 16.6666Z",
    stroke: "#096F00",
    strokeWidth: 1.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7780807c2ae98965546bce3e23c9f51d.svg";
export { ForwardRef as ReactComponent };